"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_js_1 = __importDefault(require("i18n-js"));
const languages_1 = __importDefault(require("./languages"));
exports.languages = languages_1.default;
i18n_js_1.default.translations = languages_1.default;
exports.init = ({ ...props }) => {
    for (const [key, value] of Object.entries(props)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        i18n_js_1.default[key] = value;
    }
    i18n_js_1.default.translations = languages_1.default;
};
function translate(name, options) {
    return i18n_js_1.default.translate(name, options);
}
exports.translate = translate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxzREFBMEI7QUFDMUIsNERBQW1DO0FBMEMzQixvQkExQ0QsbUJBQVMsQ0EwQ0M7QUF2Q2pCLGlCQUFJLENBQUMsWUFBWSxHQUFHLG1CQUFTLENBQUE7QUFFaEIsUUFBQSxJQUFJLEdBQUcsQ0FBQyxFQUFDLEdBQUcsS0FBSyxFQUF1QixFQUFFLEVBQUU7SUFDckQsS0FBSyxNQUFNLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxJQUFJLE1BQU0sQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLEVBQUU7UUFDOUMsOERBQThEO1FBQzlELENBQUM7UUFBQyxpQkFBWSxDQUFDLEdBQUcsQ0FBQyxHQUFHLEtBQUssQ0FBQTtLQUM5QjtJQUNELGlCQUFJLENBQUMsWUFBWSxHQUFHLG1CQUFTLENBQUE7QUFDakMsQ0FBQyxDQUFBO0FBd0JELFNBQWdCLFNBQVMsQ0FDckIsSUFBVSxFQUNWLE9BQXlFO0lBRXpFLE9BQU8saUJBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxFQUFFLE9BQU8sQ0FBQyxDQUFBO0FBQ3hDLENBQUM7QUFMRCw4QkFLQyJ9